<div class="user-image-renderer" *ngIf="user">
    <span class="user-image-renderer_initials">
        {{userInitials}}
    </span>
    <img *ngIf="user && user.profile_picture" ftImageFallback [src]="user.profile_picture" alt="">
</div>
